module.exports = __webpack_public_path__ + "site/img/icon-light.99300392.svg";